import { createReducer, on } from '@ngrx/store';
import { PHASE_THREE } from '../../../model/phases.model';
import * as phaseThreeAction from './phase-three-actions';

export const phaseThreeInitialState: PHASE_THREE = {
  FiveData: undefined,
  DoneBySkip: false,
};

export const phaseThreeReducer = createReducer(
  phaseThreeInitialState,
  on(phaseThreeAction.ADD_PHASE_THREE, (state: PHASE_THREE, { payload }) => {
    return { ...payload };
  })
  // on(phaseOneAction.GET_PHASE_ONE_DATA, (state: PHASE_ONE) => state)
);
